import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const links = [
  ["/", "Home"],
  ["/about", "About"],
  ["/services", "Services"],
  ["/projects", "Projects"],
  ["/contact", "Contact"],
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 40);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <header className={`header${scrolled ? " scrolled" : ""}`} id="siteHeader">
      <Link className="logo" to="/" aria-label="FinFlux Ventures and Partners home">
        <img src="/assets/logo.webp" alt="FinFlux logo" />
        <span className="brand-copy">
          <span className="brand-name">FINFLUX VENTURES &amp; PARTNERS</span>
          <span className="brand-tagline">FinTech Meets Aviation</span>
        </span>
      </Link>
      <nav className={`navbar${menuOpen ? " active" : ""}`} id="navbar" aria-label="Main navigation">
        {links.map(([to, label]) => (
          <NavLink key={to} to={to} onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active-link" : undefined}>
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="header-right">
        <Link to="/contact" className="btn"><span className="btn-slide" data-label="Get In Touch">Get In Touch</span></Link>
        <button
          type="button"
          className="menu-toggle"
          id="menuToggle"
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span aria-hidden="true">{"\u2630"}</span>
        </button>
      </div>
    </header>
  );
}
